/* Library */
import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { browserHistory } from 'react-router';
// import actions
import * as createEventObject from '../../../createEvent/actions';
import * as GiftRegistryAddressActions from './actions';

// import utils
import commonUtil from '../../../../utils/commonUtil';
import { eventType, constAPISuccess, ownerLabel } from '../../../../utils/clientConstant';

// import components
import InputButton from '../../../../components/ZUILib/InputButton';
import GiftRegistryMultipleAddressBody from './components/giftRegistryMultipleAddress';
import GiftRegistryHeader from './components/giftRegistryHeader';
import ApplyCSS from '../../../../components/ApplyCSS';
import EventWizard from './../EventWizard';

import { createTag } from '../../../../utils/googleTagManagerUtils';
import { addAddressIcon } from '../../../../components/NewHeader/Header/svgIcons';


const applicationRoutes = commonUtil.getApplicationRoutes();

const { defineCreateEventData } = createEventObject;
const channel = commonUtil.getChannel();
const pageName = 'registerGiftDelivery';


@connect(store => ({
  lables: store.labels.data,
  user: store.user.data,
  error: store.labels.error,
  loading: store.labels.loading,
  extraData: store.labels.extraData,
  giftRegistryAddress: store.giftRegistryAddress.data,
  createEventObject: store.createEventObject,
  eventcategory: store.eventcategory,
}),
  { ...GiftRegistryAddressActions })

class GiftRegistryAddress extends Component {

  constructor(props) {
    super(props);
    this.currentIndex = 0;
    this.maxAddress = 0;
    this.minAddress = 0;
    this.addressToBeSelected = 0;
    this.currentEvent = this.props.createEventObject.SelectTypeCelebration.selectedEventConfiguration.name;
    this.validate = this.validate.bind(this);
    this.redirectNextPage = this.redirectNextPage.bind(this);
    this.prioritiesOptions = [];
    this.celebName = null;
    this.prepopulateData = [];
    this.multiAddress = null;
    this.editSuccess = this.props.state && this.props.state.routing && this.props.state.routing.locationBeforeTransitions &&
      this.props.state.routing.locationBeforeTransitions.query && this.props.state.routing.locationBeforeTransitions.query.addressUpdated;
    this.state = {
      noOfAddressSelected : 0
    }
  }
  setNoAddressSelected = (data) => {
    this.setState({ noOfAddressSelected: data })
  }
  componentDidMount() {
    this.props.onReference(this);
    if (document) {
      document.querySelector('.mainContainer').classList.add(this.props.animationClass);
    }
    commonUtil.goToTop();
  }

  validate(validationCallBack) {
    const multi = this.multiAddress;
    let noAddress = '';
    if (this.props.giftRegistryAddress && this.props.giftRegistryAddress.status.status !== constAPISuccess) {
      noAddress = this.noAddress.validated(false);
    } else {
      noAddress = this.noAddress.validated(multi.selectedAddressforValidation());
    }
    const isControlValid = multi.validated();

    if (!isControlValid && !_.isEmpty(_.get(this.noAddress, 'warning.errormsg.innerText'))) {
      createTag({
        event: 'alerta',
        phase: 'Crear mesa de regalos',
        step: 'Direccion del evento',
        color: 'Rojo',
        mensaje: 'Datos incompletos direccion evento',
        mensaje_servicio: _.get(this.noAddress, 'warning.errormsg.innerText', 'undefined error'),
        seccion: 'Mesa de Regalos',
        tipo: 'formulario',
      });
    } else if (isControlValid) {
      const selectedAddressInTable = this.multiAddress.selectedAddresses.some(a => a.address.isEventAssociated);
      createTag({
        event: 'mesa_regalos',
        phase: 'Crear mesa de regalos',
        step: 'Seleccionar direccion',
        selection: `${this.props.createEventObject.SelectMesaType}|${this.props.createEventObject.SelectTypeCelebration.selectedEventConfiguration.name}`,
        seccion: 'Mesa de Regalos',
        flag: selectedAddressInTable ? 'Y' : 'N',
      });
    }

    if (noAddress) {
      if (isControlValid) {
        const { defineCreateEventData } = this.props; // eslint-disable-line no-shadow
        defineCreateEventData(this.currentIndex, { data: multi.selectedAddresses });
      }
      validationCallBack(isControlValid);
      return isControlValid;
    }
    validationCallBack(noAddress);
    return isControlValid;
  }

  redirectNextPage() {
    createTag({
      event: 'mesa_regalos',
      phase: 'Crear mesa de regalos',
      step: 'Agregar direccion',
      selection: `${this.props.createEventObject.SelectMesaType}|${this.props.createEventObject.SelectTypeCelebration.selectedEventConfiguration.name}`,
      seccion: 'Mesa de Regalos',
    });

    this.props.removeRouteLeaveHook();
    const { defineCreateEventData } = this.props; // eslint-disable-line no-shadow
    if (this.multiAddress !== null) {
      defineCreateEventData(this.currentIndex, { data: this.multiAddress.selectedAddresses });
    }
    browserHistory.push(applicationRoutes.addDeliveryAddress);
  }

  handleEditAddressClick = () => {
    createTag({
      event: 'mesa_regalos',
      phase: 'Crear mesa de regalos',
      step: 'Editar direccion',
      selection: `${this.props.createEventObject.SelectMesaType}|${this.props.createEventObject.SelectTypeCelebration.selectedEventConfiguration.name}`,
      seccion: 'Mesa de Regalos',
    });
  }

  render() {
    const buttonForAddAddress = {
      id : "addAddressBtn",
      type: 'button',
      value: 'Agregar dirección',
      autoFocus: false,
      style: (channel === 'wap') ? 'btnNewSecondarySpecial size-Full' : 'btnNewSecondarySpecial size-Large',
      onClickHandler: this.redirectNextPage,
      // beforeIconClass: 'iconCenter glyphicon glyphicon-plus',
      // beforeImageClass: commonUtil.getAssetURL() + '/images/address_add_icon.svg'
      addressSvgIcon: addAddressIcon
    };
    const buttonForAddAddressDisabled = {
      id : "addAddressBtn",
      type: 'button',
      value: 'Agregar dirección',
      autoFocus: false,
      style: (channel === 'wap') ? 'btnNewSecondarySpecialDisabled size-Full' : 'btnNewSecondarySpecialDisabled size-Large',
      // onClickHandler: this.redirectNextPage,
      // beforeIconClass: 'iconCenter glyphicon glyphicon-plus',
      beforeImageClass: commonUtil.getAssetURL() + '/images/add_icon.svg'
    };

    const { lables, createEventObject, eventcategory } = this.props; // eslint-disable-line no-shadow
    if (createEventObject && createEventObject.SelectTypeCelebration) {
      this.currentEvent = createEventObject.SelectTypeCelebration.selectedEventConfiguration.name;
      this.currentIndex = createEventObject.SelectTypeCelebration.selectedEventConfiguration.components[2].step;
      this.prioritiesOptions = [];
      let prevIndexTwo = '';
      const prevIndexOne = this.currentEvent + '_' + this.props.currentStep;
      if (this.props.currentStep !== 1) {
        prevIndexTwo = this.currentEvent + '_' + (this.props.currentStep - 1);
      }
      if (createEventObject && createEventObject[prevIndexOne]) {
        let celebratedData = '';
        // const possibleCelebratedLabels = [ownerLabel.Celebrated, ownerLabel.Celebrated_1, ownerLabel.Celebrated_2, ownerLabel.Organizer_1, ownerLabel.Organizer_2];
        if (prevIndexTwo) {
          celebratedData = createEventObject[prevIndexTwo].data;
          celebratedData.forEach((item, index) => {
            const hasCelebrated = String(item?.ownerLabel ?? '').toLowerCase().includes(String(ownerLabel?.Celebrated ?? '').toLowerCase());
            const hasTitleMatch = String(item?.title ?? '').toLowerCase().includes(String(ownerLabel?.Celebrated ?? '').toLowerCase());
            const hasOrganizer = String(item?.ownerLabel ?? '').toLowerCase().includes(String(ownerLabel?.Organizer ?? '').toLowerCase());
            
            if (item && (hasCelebrated || hasTitleMatch || hasOrganizer)) {
              this.prioritiesOptions.push({
                option: item.firstName,
                value: item.firstName,
                id: index,
                disabled: false,
              });
            }
            if (item && (hasCelebrated || hasTitleMatch || hasOrganizer)) {
              this.celebName = item.firstName;
            }
          },
          );
          if (this.prioritiesOptions.length > 1) {
            this.celebName = '';
          }
        }
      }
      if (this.currentEvent === eventType.Boda) {
        this.prioritiesOptions.push({
          option: 'Adicional',
          value: 'Adicional',
          id: 2,
          disabled: false,
        });
      }
    }
    if (eventcategory && eventcategory.data) {
      const eventList = eventcategory.data.eventConfigurations;
      let event;
      if (eventList) {
        event = eventList.filter((event) => { // eslint-disable-line no-shadow
          if (event.name === this.currentEvent) {
            return event;
          }
          return null;
        });
      }
      this.maxAddress = parseInt(event[0].maxAddressCount, 10);
      this.minAddress = parseInt(event[0].minAddressCount, 10);
      this.addressToBeSelected = parseInt(event[0].maxAddressCount, 10);
    }
    if (createEventObject && createEventObject[this.currentIndex]) {
      this.prepopulateData = createEventObject[this.currentIndex].data;
    }
    console.log("===============setNoAddressSelected==========",this.state.noOfAddressSelected);
    
    return (
      <div className={'mainContainer grayBackground'}>
        <ApplyCSS pageName={pageName} />
        <div className={`contentBox ${this.props.currentStep == 2 && 'gr-multipleAddress-pb'}`} id="multipleAddress">
          <div className="row">
            <div className="col-xs-12 col-md-10 col-md-offset-1 wap_container_textHeaders">
              <GiftRegistryHeader lables={this.props.lables} ref={noAdd => this.noAddress = noAdd} minAddress={this.minAddress} maxAddress={this.maxAddress} addressBook={this.props.giftRegistryAddress} user={this.props.user.result} prioritiesOptions={this.prioritiesOptions} isWap={channel == 'wap' ? true : false} warningMessage={(this.multiAddress && this.multiAddress.selectedAddresses && this.multiAddress.selectedAddresses.length > this.maxAddress) ? "Máximo 2 direcciones" : null} />
              <hr className="registerGiftSolidLine visible-xs" />
              {/* <hr className="registerGiftLineSolid" /> */}
            </div>
          </div>
          {/* call addressComponent for single and multiple Address */}
          {this.props.giftRegistryAddress && this.props.giftRegistryAddress.status.status === constAPISuccess ?
            (<div className="row">
              <GiftRegistryMultipleAddressBody onEditAddressClick={this.handleEditAddressClick} successOnEdit={this.editSuccess} currentStep={this.props.currentStep} defineCreateEventData={this.props.defineCreateEventData} addressToBeSelected={this.addressToBeSelected} celebName={this.celebName} currentIndex={this.currentIndex} addressBook={this.props.giftRegistryAddress} lables={lables} ref={multiAdd => this.multiAddress = multiAdd} prioritiesOptions={this.prioritiesOptions} prepopulateData={this.prepopulateData} removeRouteLeaveHook={this.props.removeRouteLeaveHook} setNoAddressSelected={this.setNoAddressSelected} maxAddress={this.maxAddress} />
            </div>) : null}
           
            
          {/* {channel === 'wap' && this.props.giftRegistryAddress.addresses.length == 0 ? <hr className="registerGiftLineSolid visible-xs" /> : null} */}
          
          <div className={`row ${channel === 'wap' && 'addAddressBtnwAPContainer'}`}>
            {
            this.state.noOfAddressSelected < this.maxAddress ?
              <div className={`col-xs-12 col-md-10 col-md-offset-1 ${channel === 'wap' && 'addAddressBtn'}`}>
                <div className='addAddressBtnContainer'><InputButton buttonAttr={buttonForAddAddress} /> </div>
              </div> :  <div className={`col-xs-12 col-md-10 col-md-offset-1 ${channel === 'wap' && 'addAddressBtn'}`}>
                <div className='addAddressBtnContainer'><InputButton buttonAttr={{...buttonForAddAddressDisabled,disabled:"disabled"}} /> </div>
              </div>
            }
            <div className={`address-two-btnscontainer ${channel === 'wap' && 'col-xs-12'}`}>
            <EventWizard prev={this.props.eventWizardAttributes.prevAttr} next={this.props.eventWizardAttributes.nextAttr} submit={this.props.eventWizardAttributes.submitAttr} currentStep={this.props.currentStep} totalStep={this.props.totalStepsForEvent} isDisabled={this.props.giftRegistryAddress?.addresses?.length == 0 || this.state.noOfAddressSelected == 0 ? true : false} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  state,
});

const matchDispatchToProps = dispatch => bindActionCreators({ defineCreateEventData }, dispatch);

export default connect(mapStateToProps, matchDispatchToProps)(GiftRegistryAddress);
